<template>
  <CustomBottomSheet
    :refName="'StudentsWalletTransactionsReportFilter'"
    size="xl"
    :headerText="$t('Reports.studentsWalletTransaction')"
    :headerIcon="icon"
    @opened="
      setFilter();
      getDialogs();
    "
  >
    <div class="report-container">
      <div class="row report-filter">
        <CustomSelectBox
          :className="'col-md-6'"
          :id="`userWalletTransactionTypeToken`"
          :value="
            userWalletTransactions.filterData.userWalletTransactionTypeToken
          "
          :options="userWalletTransactionTypeTokenOptions"
          v-on:changeValue="
            userWalletTransactions.filterData.userWalletTransactionTypeToken =
              $event
          "
          :title="$t('UserWalletTransactions.type')"
          :imgName="'type.svg'"
        />
        <CustomSelectBox
          :className="'col-md-6'"
          :id="`userToken`"
          :value="userWalletTransactions.filterData.userToken"
          :options="userTokenOptions"
          v-on:changeValue="
            userWalletTransactions.filterData.userToken = $event
          "
          :title="$t('students.select')"
          :imgName="'students.svg'"
        />

        <DateTimePicker
          class="col-md-6"
          :id="`dateTimeStartSearch`"
          type="dateTime"
          :value="userWalletTransactions.filterData.dateTimeStartSearch"
          v-on:changeValue="
            userWalletTransactions.filterData.dateTimeStartSearch =
              $event.dateTime
          "
          :title="$t('Reports.dateTimeFrom')"
          :language="language"
        />

        <DateTimePicker
          class="col-md-6"
          :id="`dateTimeEndSearch`"
          type="dateTime"
          :value="userWalletTransactions.filterData.dateTimeEndSearch"
          v-on:changeValue="
            userWalletTransactions.filterData.dateTimeEndSearch =
              $event.dateTime
          "
          :title="$t('Reports.dateTimeTo')"
          :language="language"
        />
        <CustomInput
          :className="'col-md-12'"
          :id="`sendTo`"
          :value="userWalletTransactions.filterData.sendTo"
          v-on:changeValue="userWalletTransactions.filterData.sendTo = $event"
          :title="$t('Reports.sendTo')"
          :imgName="'email.svg'"
        />
      </div>
      <div
        v-if="reportUrl"
        class="row report-result animate__animated animate__fadeInDownBig"
      >
        <embed
          type="application/pdf"
          :src="reportUrl"
          width="400"
          height="300"
          id="pdf"
        />
      </div>
    </div>

    <div class="form-actions">
      <div class="icon-submit" @click.prevent="getReport">
        <img
          src="@/assets/images/check-icon.svg"
          :title="$t('Reports.print')"
        />
      </div>
      <div
        @click.prevent="
          closeBottomSheet('StudentsWalletTransactionsReportFilter')
        "
        class="icon-cancel"
      >
        <img src="@/assets/images/cancel-icon.svg" :title="$t('cancel')" />
      </div>
    </div>
  </CustomBottomSheet>
</template>

<script>
import CustomBottomSheet from "@/components/general/CustomBottomSheet.vue";
import CustomSelectBox from "@/components/general/CustomSelectBox.vue";
import DateTimePicker from "@/components/general/DateTimePicker.vue";
import CustomInput from "@/components/general/CustomInput.vue";
import generalMixin from "@/utils/generalMixin";
import icon from "@/assets/images/students.svg";
import { STATUS } from "@/utils/constants";
import UserWalletTransactions from "./../../../models/settings/settingsOthers/userWalletTransactions/UserWalletTransactions";
import apiUserWalletTransaction from "@/api/userWalletTransaction";
import { getFullFilePathFromServer } from "./../../../utils/functions";
import { getUsersDialog } from "@/utils/dialogsOfApi";
import { getDialogOfWalletTransactionType } from "@/utils/dialogsOfConstantsLists";
import { USER_TYPE } from "@/utils/constantLists";
import { getLanguage } from "@/utils/functions";

export default {
  mixins: [generalMixin],
  data() {
    return {
      reportUrl: "",
      isLoading: false,
      language: getLanguage(),
      userWalletTransactions: new UserWalletTransactions(),
      icon,
      userTokenOptions: [],
      userWalletTransactionTypeTokenOptions:
        getDialogOfWalletTransactionType().slice(0, 2),
      userWalletTransactionTokenOptions: [],
    };
  },
  components: {
    CustomBottomSheet,
    CustomSelectBox,
    DateTimePicker,
    CustomInput,
  },
  props: {
    userToken: {
      type: String,
      default: "",
    },
  },
  methods: {
    setFilter() {
      this.reportUrl = "";
      this.userWalletTransactions.filterData.setInitialValue();
      this.userWalletTransactions.filterData.userToken = this.userToken;
    },
    async getDialogs() {
      this.getUsersDialog();
    },
    async getUsersDialog() {
      this.isLoading = true;
      this.$emit("isLoading", true);
      let params = {
        modelName: "students",
        userTypeToken: USER_TYPE.Student,
      };

      this.userTokenOptions = await getUsersDialog(params);
      this.isLoading = false;
      this.$emit("isLoading", false);
    },

    async getReport() {
      this.$emit("isLoading", true);
      this.reportUrl = "";
      try {
        if (
          this.userWalletTransactions.filterData.dateTimeStartSearch ||
          this.userWalletTransactions.filterData.dateTimeEndSearch
        )
          this.userWalletTransactions.filterData.calendarSearchType = "CST-5";
        const response =
          await apiUserWalletTransaction.getUserWalletTransactionsReport(
            this.userWalletTransactions.filterData
          );
        if (response.data.status == STATUS.SUCCESS) {
          if (response.data.reportPath) {
            this.reportUrl = getFullFilePathFromServer(
              response.data.reportPath
            );
          } else {
            this.showMsg(this.$t("Reports.noReports"));
          }
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (error) {
        console.log(error);
        this.showMsg(this.$t("errorCatch"));
      }
      this.$emit("isLoading", false);
    },
    async created() {},
  },
};
</script>
